import { useEffect, useState } from 'react';

async function requestRecorder() {
  const stream = await navigator.mediaDevices.getUserMedia({
    audio: { sampleRate: 44100, echoCancellation: true },
  });
  return new MediaRecorder(stream);
}

const useRecorder = (audioComponentCallback, getVoiceResponse) => {
  const [isRecording, setIsRecording] = useState(false);
  const [recorder, setRecorder] = useState(null);

  useEffect(() => {
    if (recorder === null) {
      if (isRecording) {
        requestRecorder().then(setRecorder)
          // eslint-disable-next-line no-unused-vars
          .catch((err) => {
            setIsRecording(false);
            /**
             * @TODO chatbox should sends permission error message to user
             */
            // console.error(err);
          });
      }
      return;
    }

    // TODO: fix firefox permission issue
    try {
      if (isRecording) {
        recorder.start();
      } else {
        recorder.stop();
      }
    } catch (err) {
      setIsRecording(false);
      /**
       * @TODO chatbox should sends permission error message to user
       */
      // console.error(err);
    }

    const handleData = (e) => {
      const blob = new Blob([e.data], {
        type: 'audio/wav',
      });

      getVoiceResponse(blob);
      audioComponentCallback(URL.createObjectURL(e.data));
    };

    recorder.addEventListener('dataavailable', handleData);
    // eslint-disable-next-line consistent-return
    return () => recorder.removeEventListener('dataavailable', handleData);
  }, [recorder, isRecording]);

  const startRecording = () => {
    setIsRecording(true);
  };

  const stopRecording = () => {
    setIsRecording(false);
  };

  return [isRecording, startRecording, stopRecording];
};
export default useRecorder;
